import { useState } from "react"
import Flex from "../../components/Flex"
import Screen from "./components/Screen"
import { spacing } from "./styles"

import "./TranslationService.scss"
import Button from "./components/Button"
import datasource from "../../datasource"
import MobileIcon from "../../components/MobileIcon"
import TranslationRequestModal from "../../components/TranslationRequestModal"

interface Highlight {
    title: string
    text: string
}

interface Step {
    title: string
    text: string
    email?: string
}

interface TranslationServiceDoc {
    title: string
    subTitle: string
    intro: string
    heroCtaLabel: string
    highlights: {
        title: string
        items: Highlight[]
    }
    flow: {
        title: string
        subTitle: string
        steps: Step[]
    }
    cta: {
        title: string
        subTitle: string
        label: string
        email: string
    }
}

const {
    title,
    subTitle,
    intro,
    heroCtaLabel,
    highlights,
    flow,
    cta
} = datasource.translationService as TranslationServiceDoc

export default () => {

    const [requestOpen, setRequestOpen] = useState<boolean>(false)

    return (
        <div className="mb-ts">
            <Screen className="mb-ts__title-screen">
                <Flex vertical gap={spacing("xl")}>
                    <Flex align="center" justify="center" className="mb-ts__icon-box">
                        <MobileIcon.TranslationService width={46} height={46}></MobileIcon.TranslationService>
                    </Flex>
                    <div className="mb-ts__title">{title}</div>
                    <div className="mb-ts__subTitle">{subTitle}</div>
                    <div className="mb-ts__intro">{intro}</div>
                    <div className="mb-ts__hero__btn">
                        <Button onClick={() => setRequestOpen(true)}>
                            <Flex justify="center">{heroCtaLabel}</Flex>
                        </Button>
                    </div>
                </Flex>
            </Screen>

            <div className="mb-ts__highlights-box">
                <Flex vertical gap={spacing("3xl")}>
                    <div className="mb-ts__section-title">{highlights.title}</div>
                    <Flex vertical gap={spacing("3xl")}>
                        {highlights.items.map(it => <HighlightCard key={it.title} highlight={it}></HighlightCard>)}
                    </Flex>
                </Flex>
            </div>

            <div className="mb-ts__flow-box">
                <Flex vertical gap={spacing("3xl")}>
                    <Flex vertical gap={spacing("md")}>
                        <div className="mb-ts__section-title">{flow.title}</div>
                        <div className="mb-ts__section-subTitle">{flow.subTitle}</div>
                    </Flex>
                    {/* plain div, not Flex: the connecting rail is drawn on this container */}
                    <div className="mb-ts__flow__steps">
                        {flow.steps.map((step, idx) => <StepRow key={step.title} step={step} index={idx}></StepRow>)}
                    </div>
                </Flex>
            </div>

            <Screen className="mb-ts__cta-screen">
                <Flex vertical className="mb-ts__cta" gap={spacing("4xl")}>
                    <Flex vertical gap={10} align="center">
                        <div className="mb-ts__cta__title">{cta.title}</div>
                        <div className="mb-ts__cta__subTitle">{cta.subTitle}</div>
                    </Flex>
                    <div className="mb-ts__cta__btn">
                        <Button onClick={() => setRequestOpen(true)}>
                            <Flex justify="center">{cta.label}</Flex>
                        </Button>
                    </div>
                </Flex>
            </Screen>

            <TranslationRequestModal open={requestOpen} onClose={() => setRequestOpen(false)} mobile/>
        </div>
    )
}

const HighlightCard = (props: { highlight: Highlight }) => {
    return (
        <Flex vertical className="mb-highlight-card" gap={spacing("md")}>
            <div className="mb-highlight-card__title">{props.highlight.title}</div>
            <div className="mb-highlight-card__text">{props.highlight.text}</div>
        </Flex>
    )
}

const StepRow = (props: { step: Step, index: number }) => {
    return (
        <div className="mb-step-row">
            <div className="mb-step-row__rail">
                <div className="mb-step-card__badge">{props.index + 1}</div>
            </div>
            <div className="mb-step-card">
                <div className="mb-step-card__title">{props.step.title}</div>
                <div className="mb-step-card__text">
                    {props.step.text}
                    {props.step.email
                        ? <> <a className="mb-step-card__email" href={`mailto:${props.step.email}`}>{props.step.email}</a></>
                        : null}
                </div>
            </div>
        </div>
    )
}
